import { IsBoolean, IsNotEmpty, IsOptional } from "class-validator";

import { IShowElementExercise } from "./show-element-exercise.interface";

export class ShowElementExerciseDto implements IShowElementExercise {
  @IsOptional()
  @IsNotEmpty()
  sign?: string;

  @IsNotEmpty()
  exercise: string;

  @IsOptional()
  @IsBoolean()
  disabled?: boolean;
}
